export default __webpack_public_path__ + "static/media/logo.ef47c4f6.svg";